import { useState, useEffect } from "react";
import { PLAY_TABLET } from "./useDeviceContext";

export const useIsMobile = (): boolean => {
    const [isMobile, setIsMobile] = useState(() => {
    // Better initial state detection
        if (typeof window === "undefined") return false;

        // Check multiple sources for mobile detection
        const windowWidth = window.innerWidth;
        const isMobileWidth = windowWidth < PLAY_TABLET;

        // Also check for touch capability as a hint
        const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

        // If width indicates mobile OR has touch and small screen, assume mobile
        return isMobileWidth || hasTouch && windowWidth < 1024;
    });

    useEffect(() => {
        const checkMobile = () => {
            const newIsMobile = window.innerWidth < PLAY_TABLET;
            setIsMobile(newIsMobile);
        };

        // Use a small delay to let the page settle before checking
        const timeoutId = setTimeout(() => {
            checkMobile();
        }, 0);

        window.addEventListener("resize", checkMobile);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    return isMobile;
};